// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"448":"393e5553","519":"47bc2fdd","523":"4d6a4807","644":"56f3b514","672":"91874d0d","695":"7c44f3ec"}[chunkId] + ".css";
};